import React, { useEffect, useState } from "react";
import { Typography, Box, DialogTitle } from '@mui/material';
import { Dialog, useToggle } from '@genesis/ui-kit';
import useMediaQuery from '@mui/material/useMediaQuery'
import {
    InputLabel,
    MenuItem,
    Select
} from '@mui/material';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from "@mui/material/FormControl";
import Switch from "@mui/material/Switch";
import { Button,Grid } from "@mui/material";
import classes from "./specialeventsdetail.module.scss";
import { useSelector } from "react-redux";
import axios from "axios";
import axiosInstance from "../../Shared/Utill/AxiosConfig";
import UnavailableEventPopup from "./unavailableEventPopup";
import { constants, environmentVariables } from "../../Shared/Url/Constants";
import Cookie from "js-cookie";
import SnackBar from "../../Shared/Snackbar/Snackbar";
import { IsTokenValid } from "../../Shared/Utill/AuthUtil";
import { toUpperCaseString } from "../../Shared/Utill/Utills";
import { alpha, styled } from '@mui/material/styles';
import { grey } from '@mui/material/colors';
import { messages } from "../../Shared/Messages/ErrorMessages";
import UnavailablePopup from "./unavailablePopup";

const SpecialEventsDetailPopup = (props) => {
    const dialog = useToggle();
    const personDetails = useSelector((state) => state.person.personData);
    const [unavailableDialog, setunavailableDialog] = useState(false);
    const urlDetails = useSelector((state) => state.url.urlData);
    const colleagueTKN = Cookie.get('X_TKN');
    const [isAlertOpen, setAlertOpen] = React.useState({});
    const { message, severity, open } = isAlertOpen || {};
    const [startDropDown1, setstartDropDown1] = useState([]);
    const [endDropDown1, setendDropDown1] = useState([]);
    const [startDropDown2, setstartDropDown2] = useState([]);
    const [endDropDown2, setendDropDown2] = useState([]);
    const [checkedSplit, setCheckedSplit] = React.useState(props.eventdata.responseStartTime2 !== null && props.eventdata.responseEndTime2 !== null ? true : false);
    const [checkedAvailable, setcheckedAvailable] = React.useState(props.eventdata.responseAvail === 'n' || props.eventdata.responseAvail === 'N' ? true : false);
    
    // set dropdowndefault value
    const [startDropDown1Value, setstartDropDown1Value] = useState(props.eventdata.responseStartTime1);
    const [endDropDown1Value, setendDropDown1Value] = useState(props.eventdata.responseEndTime1);
    const [startDropDown2Value, setstartDropDown2Value] = useState(props.eventdata.responseStartTime2);
    const [endDropDown2Value, setendDropDown2Value] = useState(props.eventdata.responseEndTime2);

    //css media queries
    const customQuery ='@media (max-width: 768px)';
    const customQuery2 ='@media (min-width: 600px) and (max-width: 768px)';
    const customQuery3 ='@media (min-width: 768px)';
    const matches = useMediaQuery('(min-width:375px)');
    const [isMobile, setMobile] = useState(window.innerWidth > 375);
    const [tablet_desktop, setTablet_Desktop] = useState(window.innerWidth > 768);
    const languageDetails = useSelector((state) => state.selectedLanguage.selectedLanguageData);


    const BlackSwitch = styled(Switch)(({ theme }) => ({
        '& .MuiSwitch-switchBase.Mui-checked': {
          color: grey[900],
          '&:hover': {
            backgroundColor: alpha(grey[600], theme.palette.action.hoverOpacity),
          },
        },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
          backgroundColor: grey[600],
        },
      }));

  const updateMedia = () => {
    
    setTablet_Desktop(window.innerWidth > 768);
    setMobile(window.innerWidth > 375 && window.innerWidth < 768);
  };

  useEffect(() => {
    window.addEventListener("resize", updateMedia);
    return () => window.removeEventListener("resize", updateMedia);
  });

    useEffect(() => {

        // call api for dropdowns
        /*let data = {
            eventCanSelectPartial: "y",
            eventShiftSelectXminsApart: 60,
            dayDate: "2023-01-01",
            dayHoursStart: "05:00 PM",
            dayHoursEnd: "03:00 AM"
        } */
        
        /*if (IsTokenValid(colleagueTKN)) {
            let homeUrl = urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_UI_BASE_URL
            window.location.replace(`${homeUrl}login`)
          } // isTokenValid */

        let data = {
            eventCanSelectPartial: props.eventdata.eventCanSelectPartial,
            eventShiftSelectXminsApart: props.eventdata.eventShiftSelectXminsApart,
            dayDate: props.eventdata.dayDate,
            dayHoursStart: props.eventdata.dayHoursStart,
            dayHoursEnd: props.eventdata.dayHoursEnd
        }

         axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_GET_EVENT_RESPONSE_DROP_DOWN}`, 
         data,
          {
            headers:{
            'Content-Type': 'application/json',
            'Authorization':'Bearer ' + colleagueTKN,
          }}
          ).then((response) => {
        //TODO: uncomment below line to run local and comment above line 
       
            setstartDropDown1(response.data.start1);
            setendDropDown1(response.data.end1);
            setstartDropDown2(response.data.start1);
            setendDropDown2(response.data.end1);
        })
            .catch((error) => {
                //catch
                setAlertOpen({
                    open: true,
                    severity: "error",
                    message : "Please logout and try again",
                  })
            });


        dialog.show();

    }, []);


    const handleChangeSplit = (event) => {
        setCheckedSplit(event.target.checked);
        //alert(event.target.checked)
    };

    const handleChangeAvailable = (event) => {
        if(toUpperCaseString(urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_ENV) === messages.WFM_ACT_AS_USER_RISTRICT_ENV && personDetails.impersonate_admin_id !== null && personDetails.impersonate_admin_id !== undefined){
            setAlertOpen({
              open: true,
              severity: 'error',
              message : messages.WFM_ACT_AS_USER_SAVE_AVAILABILTY_ERROR,
                  })
            return;
          }
        setcheckedAvailable(event.target.checked);
        if (event.target.checked === true) {
            setunavailableDialog(true);
        } else {
            setunavailableDialog(false);
        }
    };


    const handleChangeDropdown = (event, dropdownName) => {
        if (dropdownName === "startDropDown1Value") {
            setstartDropDown1Value(event.target.value);
        } else if (dropdownName === "endDropDown1Value") {
            setendDropDown1Value(event.target.value);
        } else if (dropdownName === "startDropDown2Value") {
            setstartDropDown2Value(event.target.value);
        } else if (dropdownName === "endDropDown2Value") {
            setendDropDown2Value(event.target.value);
        }

    };

    const getDialogStyleVersion = () => {
        let widthD = "45%";
        let leftMargin = "45%";
        let spaceFromTop;
       /* if(window.innerWidth < 768){
            //mobile version
            widthD = "100%";
            leftMargin = "0%";
            spaceFromTop = "25%";
          }*/ 
          if(window.innerWidth <= 1300 ) {
            // tablet
            widthD = "85%";
            leftMargin = "8%";
          } 
          else if(window.innerWidth > 1300) {
            //desktop
            widthD = "45%";
            leftMargin = "28%";
          }
          if (window.innerWidth >=769) {
            return {
                top:spaceFromTop,
                width: widthD,
                maxWidth: widthD,
                display:"flex",
                left:leftMargin,
                minHeight: checkedSplit ? "100%" : "100%", 
                            
            }
          }
        
    }

    const handleSave = () => {

        if(toUpperCaseString(urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_ENV) === messages.WFM_ACT_AS_USER_RISTRICT_ENV && personDetails.impersonate_admin_id !== null && personDetails.impersonate_admin_id !== undefined){
            setAlertOpen({
              open: true,
              severity: 'error',
              message : messages.WFM_ACT_AS_USER_SAVE_AVAILABILTY_ERROR,
            })
            return;
          }
        
        let error  = '';
        //call the save api.
        let data = {
            eventId: props.eventdata.eventId,
            ascNbr: props.eventdata.ascNbr,
            evtDate: props.eventdata.dayDate,
            available: checkedAvailable ? 'n' : 'y',
            availStartDtm1: startDropDown1Value !== null ? startDropDown1Value : '',
            availEndDtm1: endDropDown1Value !== null ? endDropDown1Value : '',
            availStartDtm2: checkedSplit ? startDropDown2Value : '',
            availEndDtm2: checkedSplit ? endDropDown2Value : '',
            lastUpdatedBy: props.eventdata.ascNbr,
            impersonatedBy: personDetails.impersonate_admin_id,
            languageCode: languageDetails.selected !== '' ? languageDetails.selected : 'en'

        }

        let startTime1 = new Date(startDropDown1Value);
        let endTime1 = new Date(endDropDown1Value);
        let startTime2 = new Date(startDropDown2Value);
        let endTime2 = new Date(endDropDown2Value);

        console.log(data)

        if((startDropDown1Value === null || endDropDown1Value === null ) || ( (checkedSplit && toUpperCaseString(props.eventdata.eventAllowSplitShifts) !== 'N') && (startDropDown2Value === null || endDropDown2Value === null))) {
            error = "Start and end time should not be empty"
        } else if ((startTime1.getTime() >= endTime1.getTime()) || 
                   ((checkedSplit && toUpperCaseString(props.eventdata.eventAllowSplitShifts) !== 'N') && (startTime2.getTime() >= endTime2.getTime())) ||
                   ((checkedSplit && toUpperCaseString(props.eventdata.eventAllowSplitShifts) !== 'N') && (startTime2.getTime() <= endTime1.getTime()))
                  ){
            error = "Please select appropriate time for start and end" 
        } else if (toUpperCaseString(props.eventdata.eventForceMinShiftHrs) === 'Y' 
                    && (Math.floor(((endTime1 - startTime1) / (1000 * 60 * 60)) % 24) < props.eventdata.eventForceMinShiftHrsAmt)
                    || ((checkedSplit && toUpperCaseString(props.eventdata.eventAllowSplitShifts) !== 'N') && Math.floor(((endTime2 - startTime2) / (1000 * 60 * 60)) % 24) < props.eventdata.eventForceMinShiftHrsAmt)) {
            error = "Please select a minimum of " + props.eventdata.eventForceMinShiftHrsAmt + " hours of availability."
        }

        if(error !== '') {
            setAlertOpen({
                open: true,
                severity: "error",
                message : error,
              })
           // alert(error)
        } else {
      
        if (props.eventdata.responseId !== null) {
            // update record

            axiosInstance.put(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_UPDATE_BY_EVENT_ID_ASC_NBR_EVENT_DATE}`,
            data,
            { 
             headers:{
                'Content-Type': 'application/json',
                'Authorization':'Bearer ' + colleagueTKN,
            }}).then((response) => { 
            //TODO: uncomment below line to run local and comment above line 
                // success close popup
                props.onSaveSuccess("success");
                props.popupClose();

            })
                .catch((error) => {
                    //catch
                    props.onSaveSuccess("error");
                });

        } else {
            // insert new record
             axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_ADD_BY_EVENT_ID_ASC_NBR_EVENT_DATE}`,
             data,
             {
                headers:{
                'Content-Type': 'application/json',
                'Authorization':'Bearer ' + colleagueTKN,
              }}).then((response) => {  
            //TODO: uncomment below line to run local and comment above line
            
                // success close popup
                props.onSaveSuccess("success");
                props.popupClose();

            })
                .catch((error) => {
                    //catch
                    props.onSaveSuccess("error");
                });
        }
     } // else insert the value no error 

    }

    const handleAlertNotifClose = () => {
        setAlertOpen({});
      };



    const popupClose = () => {
        setcheckedAvailable(false);
        setunavailableDialog(false);
    }

    const popupSave = (msg) => {
        //setcheckedAvailable(false);
        props.onSaveSuccess(msg);
        setunavailableDialog(false);
        props.popupClose();
    }


    return (
        <div className="setup">
        <div className="spacemaker"></div>
        
        <Dialog className="componentpopcorn"

            sx={{
                    [customQuery]:{
                            '*': {},

                            '&. MuiDialogContent-root':{
                                overflow:'unset',
                                overflowY: 'initial'
                                },

                            '& .MuiDialogTitle-root':{
                                padding: "0px 0px 0px",
                                fontSize: "20px"

                            },
                            '& .MuiDialog-paper':{
                                margin:"0px",
                                scale:2,
                                height:"100%",
                                minWidth:"100%",
                                minHeight:"100%"
                            },
                            '& .MuiGrid-root':{
                                flexDirection:"column",
                                width:"100%"
                            },
                            
                            '& .MuiFormControl-root': {
                                flexDirection: "column",
                                marginRight: "21px"
                            },       
                    },
                    [customQuery2]: {
                        '& .MuiGrid-root':{
                                flexDirection:"column",
                                width:"200%"
                            },
                    },
                    [customQuery3]: {
                        '& .MuiFormControlLabel-root': {
                            marginLeft:'0px'
                        }
                    }

                }}
                PaperProps={{
                                sx: getDialogStyleVersion(),
                            }}

            open={dialog.open}
            title={<DialogTitle sx={{fontSize:"20px !important", marginBottom:"0px;"}}>Select Your Availability</DialogTitle>}
            onClose={props.popupClose}
        >
        <Box>
            {
                unavailableDialog &&
                <UnavailablePopup
                    title="Unavailable for this day"
                    message='By selecting "Unavailable," you will lose all previous selections for this day. Are you sure you want to save changes?'
                    popupClose={popupClose}
                    data={props}
                    popupSave={popupSave}
                />
            }
            <Typography style={{marginTop:"-25px"}}><span className={classes.headingDate}>{props.eventdata.dayName}, {props.eventdata.dayLong} </span></Typography>
            <Typography><span className={classes.headingTime}>Event Hours: <span translate="no">{props.eventdata.dayHoursStart} - {props.eventdata.dayHoursEnd} </span></span></Typography><br />
            <FormGroup>
                <div className={classes.unavailableHeading}>
                    <Typography >I am unavailable for this day
                        <FormControlLabel control={<Switch className={classes.unavailableSwitch} checked={checkedAvailable} color={"black"} onChange={handleChangeAvailable} />} label="" />
                    </Typography>

                </div>
                <br />
            </FormGroup>
            <div className={classes.inputGrouping}>

            
            <div className={classes.columns}>
            <FormControl className={classes.column} >
                <InputLabel id="demo-select-basic-label">Start</InputLabel>
                <Select
                    labelId="demo-select-basic-label"
                    id="demo-select-basic"
                    label="Start"
                    value={startDropDown1Value}
                    onChange={e => handleChangeDropdown(e, "startDropDown1Value")}
                    disabled={checkedAvailable ? "disabled" : ''}
                    translate="no"
                >
                    {
                        startDropDown1.map(el => <MenuItem translate="no" value={el}>{el.split(" ")[1] + " " + el.split(" ")[2]}</MenuItem>)
                    }

                </Select>
            </FormControl>
            <FormControl className={classes.column} >

                <InputLabel id="demo-select-basic-label">End</InputLabel>
                <Select
                    labelId="demo-select-basic-label"
                    id="demo-select-basic"
                    label="End"
                    value={endDropDown1Value}
                    onChange={e => handleChangeDropdown(e, "endDropDown1Value")}
                    disabled={checkedAvailable ? "disabled" : ''}
                    translate="no"
                >
                    {
                        endDropDown1.map(el => <MenuItem translate="no" value={el}>{el.split(" ")[1] + " " + el.split(" ")[2]}</MenuItem>)
                    }
                </Select>


            </FormControl>
            {!isMobile && toUpperCaseString(props.eventdata.eventAllowSplitShifts) !== 'N' &&
            <FormControlLabel className={classes.column} control={<BlackSwitch
            sx={{
                '& .MuiSwitch-switchBase.Mui-checked': {
                color: "black",
                '&:hover': {
                backgroundColor: "green",
                }
            }}} className={classes.splitMessage} checked={checkedSplit}
                onChange={handleChangeSplit} />} label="Split Shift" />
            }
            </div>
           
            </div>
           {isMobile && toUpperCaseString(props.eventdata.eventAllowSplitShifts) !== 'N' &&
            <FormControlLabel className={classes.columnForSwitch} control={<Switch className={classes.splitMessage} checked={checkedSplit}
                onChange={handleChangeSplit} color={"black"} />} label="Split Shift" />
            }
            <div className={classes.columns}>       
            {(checkedSplit && toUpperCaseString(props.eventdata.eventAllowSplitShifts) !== 'N') &&
                <>
                    <FormControl className={classes.column} style={{ marginTop: 20 }}>
                        <InputLabel id="demo-select-basic-label">Start</InputLabel>
                        <Select
                            labelId="demo-select-basic-label"
                            id="demo-select-basic"
                            label="Start"
                            value={startDropDown2Value}
                            onChange={e => handleChangeDropdown(e, "startDropDown2Value")}
                            disabled={checkedAvailable ? "disabled" : ''}
                            translate="no"
                        >
                            {
                                startDropDown2.map(el => <MenuItem translate="no" value={el}>{el.split(" ")[1] + " " + el.split(" ")[2]}</MenuItem>)
                            }
                        </Select>
                    </FormControl>
                    <FormControl style={{marginTop: 20 }} className={classes.column}>
                        <InputLabel id="demo-select-basic-label">End</InputLabel>
                        <Select
                            labelId="demo-select-basic-label"
                            id="demo-select-basic"
                            label="End"
                            value={endDropDown2Value}
                            onChange={e => handleChangeDropdown(e, "endDropDown2Value")}
                            disabled={checkedAvailable ? "disabled" : ''}
                            translate="no"
                        >
                            {
                                endDropDown2.map(el => <MenuItem translate="no" value={el}>{el.split(" ")[1] + " " + el.split(" ")[2]}</MenuItem>)
                            }
                        </Select>
                    </FormControl>
                </>
            }
            </div>
        <Grid style={{marginTop: '30px',overflow:"auto"}} container spacing={2}>
            <Grid item xs={12} md={6} sm={6}>
            <Button  style={{width: '100%', padding: '10px'}} color="secondary" onClick={props.popupClose}>Cancel</Button>
            </Grid>
            <Grid item xs={12} md={6} sm={6}>
            <Button  style={{width: '100%', padding: '10px'}} onClick={handleSave} >Save</Button>
            </Grid>
        </Grid>
            <SnackBar
        open={open}
        message={message}
        severity={severity}
        onClose={handleAlertNotifClose}
        ></SnackBar>
        </Box>
        </Dialog>
        </div>
    )
}


export default SpecialEventsDetailPopup;